<template>
  <view-panel :title="title" class="overview-fix-target">
    <c-radio-button
      :store="chartTypes"
      v-model="chartType"
      slot="title"
      class="chat_switch"
      @change="onChangeChartType"
    >
      <template slot-scope="scope">
        <c-button
          type="normal"
          theme="border"
          :disable="scope.data.disable"
          :class="scope.className"
          :icon="scope.data.icon"
          @click="scope.onClick"
        ></c-button>
      </template>
    </c-radio-button>
    <div class="to-pie" ref="toChart"></div>
    <div class="empty-tip" v-if="showEmpty">暂无数据</div>
    <c-loading v-if="!store"></c-loading>
  </view-panel>
</template>
<script>
import ViewPanel from './panel'
import echarts from 'echarts'
import constants from './constants'
import { actions } from '../../store/constants'
export default {
  name: 'overViewFixTarget',
  components: {
    ViewPanel
  },
  props: {
    title: null,
    store: null,
    defaultType: null,
    field: null
  },
  data () {
    return {
      chart: null,
      chartTypes: [
        {
          icon: 'icon-pie',
          value: 'pie'
        },
        {
          icon: 'icon-analysis',
          value: 'bar'
        }
      ],
      chartType: this.defaultType || 'pie'
    }
  },
  computed: {
    options () {
      return this.chartType === 'pie' ? this.pieOptions : this.barOptions
    },
    showEmpty () {
      return !this.store || JSON.stringify(this.store) === '{}'
    },
    pieOptions () {
      if (!this.store) return null
      const data = []
      for (const name in this.store) {
        data.push({
          name,
          value: this.store[name]
        })
      }
      return {
        color: constants.color,
        tooltip: {
          show: true,
          confine: true,
          formatter (params) {
            return `${params.seriesName}<br/>${params.marker}${params.name}: ${
              params.value
            }人 (${params.percent}%)`
          }
        },
        series: [
          {
            name: this.title,
            type: 'pie',
            radius: ['50%', '85%'],
            selectedMode: 'single',
            label: {
              show: false,
              position: 'center',
              formatter: '{b}: {d}%',
              color: 'black'
            },
            emphasis: {
              label: {
                show: true
              }
            },
            data
          }
        ]
      }
    },
    barOptions () {
      if (!this.store) return null
      const seriesData = []
      const yData = []
      let count = 0
      for (const name in this.store) {
        yData.push(name)
        seriesData.push(this.store[name])
        count += this.store[name]
      }
      const options = {
        grid: {
          top: 10,
          bottom: 20,
          left: 40
        },
        tooltip: {
          show: true,
          confine: true,
          formatter (params) {
            return `${params.seriesName}<br/>${params.marker}${params.name}: ${
              params.value
            }人 (${((params.value / count) * 100).toFixed(2)}%)`
          }
        },
        xAxis: {
          type: 'value',
          show: false
        },
        yAxis: {
          type: 'category',
          data: yData,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        series: {
          name: this.title,
          type: 'bar',
          barMaxWidth: 24,
          data: seriesData.map((value, index) => {
            return {
              value,
              itemStyle: {
                color: constants.color[index]
              }
            }
          })
        }
      }
      return options
    }
  },
  watch: {
    store (store) {
      if (!store) return
      this.$nextTick(() => {
        this.chart.setOption(this.options)
      })
    }
  },
  mounted () {
    this.chart = echarts.init(this.$refs.toChart)
    if (this.options) this.chart.setOption(this.options)
  },
  beforeDestroy () {
    if (this.chart) this.chart.dispose()
    this.chart = null
  },
  methods: {
    onChangeChartType () {
      this.chart.dispose()
      this.chart = null
      this.chart = echarts.init(this.$refs.toChart)
      this.chart.setOption(this.options)
      window.track('实时概览-切换图表类型', {
        图表类型: this.chartType === 'bar' ? '柱状图' : '环形图'
      })
      this.$store
        .dispatch(actions.dataview.updateChartType, {
          appId: this.appId,
          target: this.field,
          type: this.chartType
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: '保存图表类型失败'
          })
          console.error('保存图表类型失败', error)
        })
    }
  }
}
</script>
<style lang="sass">
@import '../../assets/constants'
.overview-fix-target
  .chat_switch
    float: right
    .c-button
      height: 28px
      line-height: 28px
      font-size: $size-font-content-medium
  .to-pie
    height: 100%
</style>
